export const requiredIf = (
  fieldKey: string,
  fieldValues: unknown[],
  formData: Record<string, unknown> | null,
) => {
  return (value: string) => {
    if (!value && formData && fieldValues.includes(formData[fieldKey])) {
      return 'Campo obrigatório';
    }

    return null;
  };
};
